export default __webpack_public_path__ + "static/media/nut.eba10089.png";